import {postMessage} from '../../frame/FrameActions';
import {reloadLayer} from './AbstractMapActions';

export {reloadLayer};

/**
 * Načte daný seznam featues.
 *
 * @param {string} area - oblast store
 * @param {Array} features - seznam features pro načtení
 * @param {Object} [options] - volitelné parametry
 * @param {boolean} [options.zoom=true] - zda provést zoom na načtené features
 * @returns {Object} akce
 */
export function loadFeatures(area, features, options = {}) {
    const {zoom = true} = options;
    return postMessage(area, {type: 'FEATURE_LOAD', features, zoom});
}

/**
 * Vybere features s danými ID.
 * Předání prázdného seznamu zruší aktuální výběr.
 *
 * @param {string} area - oblast store
 * @param {Array<string|number>} featureIds - seznam ID features pro výběr
 * @param {Object} [options] - volitelné parametry
 * @param {boolean} [options.shallow=false] - příznak pro transakční režim označující "mělký" výběr.
 *      Při tomto výběru nejsou dané features skutečně označeny, pouze jsou přidány do transakce.
 *      Tzn. nejde nad nimi např. provést mazání, ale lze k nim v rámci transakce (MULTI/PARTIAL režim)
 *      přidat novou feature v rámci skupiny
 * @returns {Object} akce
 */
export function selectFeatures(area, featureIds, options = {}) {
    const {shallow = false} = options;
    return postMessage(area, {type: 'FEATURE_SELECT', featureIds, shallow});
}

/**
 * Aktivuje nástroj s danými ID.
 *
 * @param {string} area - oblast store
 * @param {string} toolId - ID nástroje
 * @returns {Object} akce
 */
export function activateToolWithId(area, toolId) {
    return postMessage(area, {type: 'TOOL_ACTIVATION', toolId});
}

/**
 * Aktivuje nástroj s danými typem.
 *
 * @param {string} area - oblast store
 * @param {string} toolType - typ nástroje
 * @returns {Object} akce
 */
export function activateToolWithType(area, toolType) {
    return postMessage(area, {type: 'TOOL_ACTIVATION', toolType});
}

/**
 * Spustí novou transakci.
 *
 * @param {string} area - oblast store
 * @returns {Object} akce
 */
export function startTransaction(area) {
    return postMessage(area, {type: 'TRANSACTION_START'});
}

/**
 * Potvrdí změny v probíhající transakci a ukončí ji.
 *
 * @param {string} area - oblast store
 * @returns {Object} akce
 */
export function commitTransaction(area) {
    return postMessage(area, {type: 'TRANSACTION_COMMIT'});
}

/**
 * Vrátí změny v probíhající transakci a ukončí ji.
 *
 * @param {string} area - oblast store
 * @returns {Object} akce
 */
export function rollbackTransaction(area) {
    return postMessage(area, {type: 'TRANSACTION_ROLLBACK'});
}
